import fastclick from 'fastclick';
import App from './App.vue';
import './assets/styles/reset.css';
import './assets/styles/border.css';
import './assets/styles/font/iconfont.css';
import 'vant/es/notify/style';
import 'vant/es/toast/style';
import 'vant/es/dialog/style';
import 'vant/es/image-preview/style';
fastclick.attach(document.body);
const app = createApp(App);
app.use(store).use(router);
app.mount('#app');